import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { LocaleState } from '@merchant-portal/merchant-portal-base'
import { Box } from '@resurs/midas-react'
import { colors } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels'
import Page from '../../../../internal/Page'
import PageActionBar from '../../../../internal/PageActionBar'
import { getDeep } from '../../../../util/helpers'
import TransactionOrderInfo from '../../TransactionOrderInfo'
import TransactionHistory from '../../TransactionHistory'
import styles from '../../shared/transactions.style'
import govIdFormat from '../../../../util/govIdFormat'

import TransactionCartEcom from '../../TransactionCart/TransactionCartEcom'
import { TransactionStatus } from '../../../../util/transactionConstants'

class AdvancedTransactionDetailsUI extends React.PureComponent {
  render() {
    const grayLabel = label => (
      <span style={styles.grayNameLabel}>{getText(label)} </span>
    )

    const govIdLabel = transactionDetails => {
      if (
        transactionDetails &&
        transactionDetails.customer &&
        transactionDetails.customer.governmentId
      ) {
        return ` (${govIdFormat(
          transactionDetails.customer.governmentId,
          this.context.country,
        )})`
      }

      return null
    }

    const customerFullName = getDeep(
      this.props.transactionDetails,
      'customer.customerGivenAddress.name.full',
    )

    return (
      <>
        <Page title={getText('transactions.transaction.title')}>
          <PageActionBar
            items={
              <h6 style={styles.name}>
                {grayLabel(
                  'transactions.transaction.orderDetails.customerLabel',
                )}
                {customerFullName}
                {govIdLabel(this.props.transactionDetails)}
              </h6>
            }
          />
          <TransactionOrderInfo
            transactionDetails={this.props.transactionDetails}
            transaction={this.props.transaction}
          />
        </Page>

        <Conditional
          when={
            !!this.props.transactionDetails &&
            this.props.transactionDetails.status === TransactionStatus.FROZEN
          }
        >
          <Box type="danger">
            <h5 style={{ margin: '1rem 1rem 0 0' }}>
              <span style={{ ...styles.name, color: colors.errorMain }}>
                {getText('transactions.frozen')}
              </span>
            </h5>

            <div style={{ padding: '1rem' }}>
              {getText('transactions.infoFrozen')}
            </div>
          </Box>
        </Conditional>

        <Page title={getText('transactions.transaction.specification.title')}>
          <PageActionBar
            items={
              <h6 style={styles.name}>
                {grayLabel(
                  'transactions.transaction.specification.orderIdLabel',
                )}
                {(this.props.transactionDetails &&
                  this.props.transactionDetails.externalId) ||
                  ''}
              </h6>
            }
          />

          <TransactionCartEcom
            transactionDetails={this.props.transactionDetails}
            orderLimit={this.props.orderLimit}
          />
          <TransactionHistory details={this.props.transactionDetails} />
        </Page>
      </>
    )
  }
}

AdvancedTransactionDetailsUI.propTypes = {
  transactionDetails: PropTypes.object,
  transaction: PropTypes.object,
  orderLimit: PropTypes.number,
}

AdvancedTransactionDetailsUI.defaultProps = {
  transactionDetails: null,
  transaction: null,
  orderLimit: 0,
}

AdvancedTransactionDetailsUI.contextType = LocaleState
export default AdvancedTransactionDetailsUI
